import React from 'react';
import moment from 'moment-timezone';
import { OpeningHoursWithExceptions, Duration } from 'common/types';
import { getOpeningTimesForDateWithMoments } from 'common/utils/shopUtils';
import {
	AvailabilityByTime,
	ValidSlotsByTime,
} from 'common/modules/availabilities/timeSlots/types';
import { TimeSelectorArgs, TimeSelectorStyling } from 'components/TimeSelector/types';
import TimeSlotListHeader from './TimeSlotListHeader';
import TimeSlots from './TimeSlots';
import TimeSlotListFooter from './TimeSlotListFooter';

interface Props {
	existingDateSelection: string;
	onSelectDate: (data: moment.Moment) => void;
	onToggleShowTimesOutsideOpeningHours: (value: boolean) => void;
	timeSlots: AvailabilityByTime | ValidSlotsByTime;
	loading: boolean;
	selectorType: TimeSelectorArgs;
	duration: Duration;
	hasProducts: boolean;
	showAvailability: boolean;
	openingHours: OpeningHoursWithExceptions;
	showTimesOutsideOpeningHours: boolean;
	overbookedBanner: boolean;
	styling?: TimeSelectorStyling;
	minDate?: moment.Moment;
}

const TimeSlotList = (props: Props) => {
	const {
		onSelectDate,
		openingHours,
		showTimesOutsideOpeningHours,
		onToggleShowTimesOutsideOpeningHours,
		hasProducts,
		showAvailability,
		loading,
		timeSlots,
		selectorType,
		duration,
		existingDateSelection,
		styling,
		minDate,
		overbookedBanner,
	} = props;
	if (!timeSlots) return null;
	const openingTimes = getOpeningTimesForDateWithMoments(
		moment(existingDateSelection),
		openingHours,
	);

	return (
		<>
			<TimeSlotListHeader
				openingTimes={openingTimes}
				date={existingDateSelection}
				showTimesOutsideOpeningHours={showTimesOutsideOpeningHours}
				onToggleShowTimesOutsideOpeningHours={onToggleShowTimesOutsideOpeningHours}
				overbookedBanner={overbookedBanner}
			/>
			<TimeSlots
				existingDateSelection={existingDateSelection}
				onSelectDate={onSelectDate}
				timeSlots={timeSlots}
				openingHours={openingHours}
				openingTimes={openingTimes}
				selectorType={selectorType}
				showTimesOutsideOpeningHours={showTimesOutsideOpeningHours}
				loading={loading}
				showAvailability={hasProducts && showAvailability}
				duration={duration}
				styling={styling}
				minDate={minDate}
			/>
			<TimeSlotListFooter loading={loading} hasProducts={hasProducts} />
		</>
	);
};

export default TimeSlotList;
